(function(angular){
	'use strict';
	
	var reitElementListObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		bindings: {
			reitElements: '<'
		},
		controller: [
			'$filter',
			'$rootScope',
			'$scope',
			ReitElementListFunction
		],
		controllerAs: 'reitElementList'
	};
	
	angular
		.module('reitElementListingModule')
		.component('reitElementList', reitElementListObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/reit-element-container/reit-element-list.html';
	}

	function ReitElementListFunction(
		$filter,
		$rootScope,
		$scope
	){
		var reitElementList = this;

		reitElementList.$onInit = function() {
			reitElementList.pageSize = 10;
			reitElementList.currentPage = 0;
			reitElementList.sortBy = 'riskScore';
			reitElementList.reitElements = reitElementList.reitElements || [];
			reitElementList.reitElements = $filter('orderBy')(reitElementList.reitElements, reitElementList.sortBy);
		};

		reitElementList.$onChanges = function(changesObj) {
			if(angular.isDefined(changesObj.reitElements)) {
				reitElementList.currentPage = 0;				
			}
		};

		reitElementList.changeSort = function(type) {
			if(type === reitElementList.sortBy) {
				reitElementList.sortBy = '-' + reitElementList.sortBy;
			} else {
				reitElementList.sortBy = type;
			}

			reitElementList.currentPage = 0;
			reitElementList.reitElements = $filter('orderBy')(reitElementList.reitElements, reitElementList.sortBy);
		};

		$scope.$on('pagination:update', function(evt, data) {
			reitElementList.currentPage = data.currentPage;
		});

		reitElementList.openModal = function(reitElementListItem) {
			$rootScope.ModalFactory.openReitElement({
				reitElement: reitElementListItem
			});
		};
	}
})(window.angular);